<template>
  <div class="outerDiv">
    <div class="MCQquestion" :class="getCSSClass" @click="$emit('changeCurrent', item.number - 1)">
      <div class="displayCircle">
        <CircleComponent :id="item.number" :current-class="getCurrentCircleClass"></CircleComponent>
      </div>
      <div v-if="item.cls == 'Programming'" class="description" :class="getDescriptionClass">
        {{ item.name }}
      </div>
      <div v-else class="description" :class="getDescriptionClass" v-html="item.description"></div>
      <div class="marks">
        <div class="correct">+{{ item.marks.correct }}</div>
        <div class="incorrect">-{{ item.marks.incorrect }}</div>
      </div>
    </div>
    <div :class="borderActive"></div>
  </div>
</template>

<script>
'emit'
import CircleComponent from './Circle'
export default {
  name: 'MCQ',
  components: { CircleComponent },
  props: ['item', 'isCurrent'],
  computed: {
    getCSSClass: function () {
      if (this.isCurrent) return 'activeQuestion'
      return this.item.currentClass.concat('Question')
    },
    borderActive: function () {
      if (this.item.currentClass === 'active') {
        return 'notBorder'
      } else {
        return 'border'
      }
    },
    getDescriptionClass: function () {
      if (this.item.currentClass === 'saved') {
        return this.item.currentClass.concat('Description')
      } else {
        return 'normalDescription'
      }
    },
    getCurrentCircleClass: function () {
      var cssClass = ''
      if (this.isCurrent) cssClass = 'currentDot'
      else if (this.item.currentClass === 'normal') cssClass = 'notActiveDot'
      return cssClass + ' ' + this.item.currentClass + 'Dot'
    },
  },
  mounted() {
    this.$nextTick(function () {
      // Use the below for MathJax version <3
      // MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.body])

      // For MathJax version 3.0 and above use below
      MathJax.typeset();
    });
  },
  updated() {
    MathJax.typeset();
  },
}
</script>

<style scoped>
.outerDiv {
  -webkit-user-select: none;
  /* webkit (safari, chrome) browsers */
  -moz-user-select: none;
  /* mozilla browsers */
  -khtml-user-select: none;
  /* webkit (konqueror) browsers */
  -ms-user-select: none;
  /* IE10+ */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.MCQquestion {
  -webkit-user-select: none;
  /* webkit (safari, chrome) browsers */
  -moz-user-select: none;
  /* mozilla browsers */
  -khtml-user-select: none;
  /* webkit (konqueror) browsers */
  -ms-user-select: none;
  /* IE10+ */
  cursor: pointer;
  font-family: Roboto-Regular;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 0;
}

.activeQuestion {
  background: #f7f8f9;
  box-shadow: inset 4px 0 0 0 #0988f4;
}

.notActiveQuestion,
.reviewQuestion {
  background: #ffffff;
}

.displayCircle {
  display: flex;
  align-items: center;
  width: 40px;
}

.description {
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.8;
  line-height: 20px;
  font-size: 13px;
  margin: 2px 4px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 280px;
}

.normalDescription {
  color: #212223;
}

.savedDescription {
  color: #a8b2c6;
}

.marks {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
}

.correct {
  height: 14px;
  font-size: 12px;
  color: #1bc09c;
}

.incorrect {
  height: 14px;
  font-size: 12px;
  color: #f66957;
}

.border {
  box-sizing: border-box;
  border: 1px solid #efeef3;
}

.notBorder {
  box-sizing: border-box;
  border: 1px solid #ffffff;
}

@media only screen and (max-width: 1440px) {
  .description {
    width: 200px;
  }
}
</style>
